<template>
  <v-card flat dense>
    <v-card-title>
      {{ $t('ITEM.VIEW') }} {{ $t('ADDRESSES.ITEM') }}
      <v-spacer />
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid">
        <address-form
          v-model="address"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn depressed color="primary" :disabled="!valid" @click="create">
        {{ $t('BUTTON.UPDATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import AddressForm from '@/modules/addresses/components/forms/AddressForm';

export default {
  name: 'ViewAddress',

  components: {
    AddressForm
  },

  mixins: [errors],

  props: {
    personId: {
      type: Number,
      required: true
    },
    addressId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      valid: false,
      address: {}
    };
  },

  mounted() {
    this.getAddress({
      personId: this.personId,
      addressId: this.addressId
    }).then(({ data }) => {
      this.address = data.data;
    });
  },

  methods: {
    ...mapActions('person', ['updateAddress', 'getAddress']),

    cancel() {
      this.$emit('cancel');
    },

    create() {
      this.updateAddress({
        address: this.address,
        addressId: this.address.id,
        personId: this.personId
      })
        .then(({ data }) => {
          this.$emit('updated', data.data);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>
